/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';

import { ScheduleTaskDetailsBusinessService } from '../../../resources/schedule-task-details-business.service';
import { ScheduleTaskDetailsTodoDialogComponent } from './schedule-task-todo-dialog.component';

export const scheduleTaskTodoDialog = createDialogRoute({
  component: ScheduleTaskDetailsTodoDialogComponent,
  init: {
    service: ScheduleTaskDetailsBusinessService,
    selector: 'initTodoDialogView',
  },
});
